import React, { useState, useContext } from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'

import { LangContext } from 'context'
import MobileNav from './MobileNav'
import MainLogo from 'components/elements/MainLogo'
import { DEFAULT_LANG } from 'config/languages'
import { LeftSide, RightSide, StyledHeader, StyledMainLogo, StyledSpan, StyledNavButton } from './styles'
import HamburgerBtn from './HamburgerBtn'
import DesktopControls from './DesktopControls'
import DesktopMenu from './DesktopMenu'
import { ThemeContext } from 'context/themeContext'

export default function Header({ searchPlaceholder, newsletterText, menu }) {
   const [menuOpened, handleMenuOpened] = useState(false)

   const { langConfig } = useStaticQuery(query)
   const { lang, path } = useContext(LangContext)
   const { toggleTheme } = useContext(ThemeContext)
   const langPrefix = lang === DEFAULT_LANG ? '' : `/${lang}`
   const languages =
      Array.isArray(langConfig.nodes) &&
      langConfig.nodes.reduce((acc, nextItem) => {
         nextItem.langItems.filter((item) => item.lang !== lang).forEach((item) => acc.push(item))
         return acc
      }, [])

   return (
      <>
         <StyledHeader>
            <LeftSide>
               <StyledMainLogo onClick={() => handleMenuOpened(false)}>
                  <MainLogo lang={lang} />
               </StyledMainLogo>
               <DesktopMenu menu={menu} lang={lang} path={path} />
            </LeftSide>
            <RightSide>
               <DesktopControls
                  languages={languages}
                  lang={lang}
                  path={!langPrefix ? path : path.replace(langPrefix, '')}
                  handleDarkMode={toggleTheme}
                  newsletterText={newsletterText}
               />
               <Link href={lang === DEFAULT_LANG ? `/contact/` : `/${lang}/contact/`}>
                  <StyledNavButton variant="dark">
                     <StyledSpan>Contact Us</StyledSpan>
                  </StyledNavButton>
               </Link>
               <HamburgerBtn isOpen={menuOpened} onClick={() => handleMenuOpened(!menuOpened)} />
            </RightSide>
         </StyledHeader>
         <MobileNav
            opened={menuOpened}
            handleMenuOpened={handleMenuOpened}
            handleDarkMode={toggleTheme}
            searchPlaceholder={searchPlaceholder}
            languages={languages}
            lang={lang}
            path={!langPrefix ? path : path.replace(langPrefix, '')}
            menu={menu}
         />
      </>
   )
}

const query = graphql`
   query langSelectorQuery {
      langConfig: allContentfulPartialLangSelector(filter: { node_locale: { eq: "en-US" } }) {
         nodes {
            node_locale
            langItems {
               lang
               label
               disabled
            }
         }
      }
   }
`
